(function () {
  if (typeof Storage === "undefined") {
    console.warn("Storage is not supported.");
    return;
  }

  // =========================
  // RUN ONLY ON FRAGFLEX
  // =========================
  const isFragflexSite = window.location.hostname.includes("fragflex.com");
  if (!isFragflexSite) return;

  // =========================
  // BASIC BOT CHECK
  // =========================
  const userAgent = navigator.userAgent.toLowerCase();
  const isBot =
    /(bot|crawl|slurp|spider|mediapartners|facebookexternalhit|pinterest|crawler|bingpreview|ahrefs|yandex|baiduspider)/.test(
      userAgent,
    );

  if (isBot) return;

  // =========================
  // PREVENT CROSS-DOMAIN LOOP
  // =========================
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get("redirected") === "true") {
    const url = new URL(window.location.href);
    url.searchParams.delete("redirected");

    window.history.replaceState({}, document.title, url.pathname + url.search);

    return;
  }

  // helper to normalize hostnames
  function normalizeHost(hostname) {
    return hostname.replace(/^www\./, "");
  }

  // =========================
  // USER PREFERRED SITE (note: if user already chose this domain - do not show modal)
  // Normalize hostname by stripping leading "www." so that fragflex.com and
  // www.fragflex.com are treated as the same preferred site.
  // =========================
  function normalizeHostname(hostname) {
    return hostname.replace(/^www\./, "");
  }

  const preferredSite = localStorage.getItem("preferredSite");

  if (
    preferredSite &&
    preferredSite === normalizeHost(window.location.hostname)
  ) {
    return;
  }

  // Prevent showing modal repeatedly in the same session
  if (sessionStorage.getItem("redirectModalDismissed")) return;

  // =========================
  // REDIRECT COUNTRIES CONFIG
  // =========================
  const REDIRECT_COUNTRIES = [
    "CA",
    "GB",
    "AU",
    "DE",
    "FR",
    "IT",
    "ES",
    "NL",
    "BE",
    "SE",
    "DK",
    "FI",
    "IE",
    "PL",
    "PT",
    "AT",
    "CZ",
    "RO",
    "HU",
    "GR",
    "BG",
    "HR",
    "SI",
    "SK",
    "LT",
    "LV",
    "EE",
    "LU",
    "MT",
    "CY",
  ];

  // =========================
  // FALLBACK FOR OLD BROWSERS
  // =========================
  const COUNTRY_NAMES = {
    CA: "Canada",
    GB: "United Kingdom",
    AU: "Australia",
    DE: "Germany",
    FR: "France",
    IT: "Italy",
    ES: "Spain",
    NL: "Netherlands",
    BE: "Belgium",
    SE: "Sweden",
    DK: "Denmark",
    FI: "Finland",
    IE: "Ireland",
    PL: "Poland",
    PT: "Portugal",
    AT: "Austria",
    CZ: "Czech Republic",
    RO: "Romania",
    HU: "Hungary",
    GR: "Greece",
    BG: "Bulgaria",
    HR: "Croatia",
    SI: "Slovenia",
    SK: "Slovakia",
    LT: "Lithuania",
    LV: "Latvia",
    EE: "Estonia",
    LU: "Luxembourg",
    MT: "Malta",
    CY: "Cyprus",
  };

  function handleRedirectVisitor(country) {
    const modal = document.getElementById("redirect-modal");
    if (!modal) return;

    // =========================
    // LOCALIZED COUNTRY NAME
    // =========================
    const locale = document.documentElement.lang || "en";
    let readableCountry;
    if (typeof Intl.DisplayNames === "function") {
      const regionNames = new Intl.DisplayNames([locale], { type: "region" });
      readableCountry = regionNames.of(country) || COUNTRY_NAMES[country];
    } else {
      readableCountry = COUNTRY_NAMES[country] || country;
    }

    // =========================
    // TITLE
    // =========================
    const titleEl = document.getElementById("redirect-modal-title");
    if (titleEl?.dataset.titleTemplate) {
      titleEl.textContent = titleEl.dataset.titleTemplate.replace(
        "__COUNTRY__",
        readableCountry,
      );
    }

    // =========================
    // DESCRIPTION
    // =========================
    const descriptionEl = document.getElementById("redirect-modal-description");

    if (descriptionEl?.dataset.descriptionTemplate) {
      const siteType =
        country === "CA"
          ? descriptionEl.dataset.siteTypeCanada
          : descriptionEl.dataset.siteTypeInternational;

      descriptionEl.innerHTML =
        descriptionEl.dataset.descriptionTemplate.replace(
          "__SITE_TYPE__",
          siteType,
        );
    }

    const counterEl = modal.querySelector("#redirect-counter");
    const stayBtn = document.getElementById("redirect-confirm");
    const continueBtn = document.getElementById("redirect-cancel");
    const btnText = continueBtn.querySelector(".redirect-button__text");
    const canadaIcon = continueBtn.querySelector(".icon-canada");
    const globeIcon = continueBtn.querySelector(".icon-globe");
    const canadaText = continueBtn.dataset.textCanada;
    const internationalText = continueBtn.dataset.textInternational;

    if (country === "CA") {
      btnText.textContent = canadaText;
      canadaIcon.style.display = "block";
      globeIcon.style.display = "none";
      continueBtn.setAttribute("aria-label", continueBtn.dataset.ariaCanada);
    } else {
      btnText.textContent = internationalText;
      canadaIcon.style.display = "none";
      globeIcon.style.display = "block";
      continueBtn.setAttribute(
        "aria-label",
        continueBtn.dataset.ariaInternational,
      );
    }

    let countdown = 20;
    let timer;

    function updateCounter() {
      counterEl.textContent = countdown;
    }

    const TARGET_ORIGIN = "https://fragrancebuy.ca";

    function redirectToTargetSite(targetOrigin = TARGET_ORIGIN) {
      const url = new URL(window.location.href);

      url.searchParams.delete("redirected");

      const query = url.searchParams.toString();

      const target = new URL(targetOrigin);
      target.pathname = url.pathname;

      if (query) {
        target.search = `?${query}`;
      }

      target.searchParams.set("redirected", "true");

      window.location.href = target.toString();
    }

    function showModal() {
      modal.classList.remove("hidden");
      requestAnimationFrame(() => modal.classList.add("active"));

      updateCounter();
      timer = setInterval(() => {
        countdown--;
        updateCounter();

        if (countdown <= 0) {
          clearInterval(timer);
          redirectToTargetSite();
        }
      }, 1000);
    }

    function closeModal() {
      modal.classList.remove("active");
      modal.addEventListener(
        "transitionend",
        () => modal.classList.add("hidden"),
        { once: true },
      );
    }

    stayBtn.addEventListener("click", () => {
      clearInterval(timer);
      closeModal();
      sessionStorage.setItem("redirectModalDismissed", "true");
      localStorage.setItem(
        "preferredSite",
        normalizeHost(window.location.hostname),
      );
    });

    continueBtn.addEventListener("click", () => {
      clearInterval(timer);
      redirectToTargetSite();
    });

    showModal();
  }

  // =========================
  // USE SHARED GEO SERVICE
  // =========================
  GeoCountryCache.getCountry(function (country) {
    if (country && REDIRECT_COUNTRIES.includes(country)) {
      handleRedirectVisitor(country);
    }
  });
})();
